const planner = {
  title: "Planificador",
  buttons: {
    newRecurrentTask: "Agregar Nueva Tarea Periódica",
    newOnetimeTask: "Agregar Nueva Tarea Única",
    cancel: "Cancelar",
    gotoTask: "IR A LA TAREA",
    doneToday: "COMPLETADO HOY",
    done: "LISTO",
    delete: "BORRAR",
    deleteOnly: "Borrar solo esta tarea",
    deleteAll: "Borrar todas las tareas",
    deleteThis: "Borrar esta tarea"
  },
  labels: {
    search: "Búsqueda por nombre",
    maintenance: "Mantenimiento",
    reliability: "Confiabilidad",
    repair: "Reparación",
    onetimeTask: "Tarea Única",
    onetime: "Única",
    recurrentTask: "Tarea Periódica",
    recurrent: "Periódica",
    itHasToBe: "Debe cambiarse cada"
  },
  tabs: {
    todo: "TAREAS PENDIENTES",
    history: "HISTORIAL"
  },
  messages: {
    notasks: "No hay tareas en el historial",
    changelog: "¿Desea cambiar el registro?"
  }
};
export default planner;
